import { render, staticRenderFns } from "./ProjectWrite.vue?vue&type=template&id=72a1587c&scoped=true"
import script from "./ProjectWrite.vue?vue&type=script&lang=js"
export * from "./ProjectWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1587c",
  null
  
)

export default component.exports